import React from "react";
import { Button, Input } from "antd";

const MDSelect = ({ name, data, itemId, itemData, selectedId, onSelect, minItemWidth = 150, gap = 6, containerStyle, form, ...props }) => {
  const minWidth = typeof minItemWidth === "number" ? `${minItemWidth}px` : minItemWidth || "150px";
  const containerInlineStyle = {
    display: "grid",
    gap,
    gridTemplateColumns: `repeat(auto-fit, minmax(${minWidth}, 1fr))`,
    ...(containerStyle || {}),
  };

  return (
    <div style={containerInlineStyle} className="md-select">
      <Input value={selectedId} style={{ display: "none" }} />
      {data.map((item) => {
        const isSelected = item[itemId] === selectedId;
        const mergedStyle = { width: "100%", ...(props.style || {}) };

        return (
          <Button
            className="ml-1 mr-1"
            type={isSelected ? "primary" : "default"}
            key={item[itemId]}
            {...props}
            onClick={() => {
              onSelect(item[itemId]);
              if (form) {
                form.setFieldsValue({ [name]: item[itemId] });
              }
            }}
            style={mergedStyle}
          >
            {item[itemData]}
          </Button>
        );
      })}
    </div>
  );
};

export default MDSelect;
